import { render, staticRenderFns } from "./LsNavbar.vue?vue&type=template&id=3bf70e6b&scoped=true&"
import script from "./LsNavbar.vue?vue&type=script&lang=js&"
export * from "./LsNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LsNavbar.vue?vue&type=style&index=0&id=3bf70e6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf70e6b",
  null
  
)

export default component.exports